import {
  Companion_instanceph7m2qn20p7q as Companion_instance,
  Companion_instancetlzvdhi57ju2 as Companion_instance_0,
  Companion_instance2z7r598ruzfgp as Companion_instance_1,
  Companion_instanceh57sw6cyw523 as Companion_instance_2,
  Never_getInstance3of1faxayn0qw as Never_getInstance,
  Always_getInstance177eud73uc475 as Always_getInstance,
  Companion_instance2q8fv6rz9kty0 as Companion_instance_3,
  Companion_instancen43ljy30xhzi as Companion_instance_4,
  Companion_instance1rxmb5wyn6fsk as Companion_instance_5,
  Companion_instance1x5ptgth8zhxi as Companion_instance_6,
  Companion_instance3sjn2yjp2itr2 as Companion_instance_7,
  Companion_instance27qzp1hsrgk5v as Companion_instance_8,
  Companion_instance2ofs92i7mv51v as Companion_instance_9,
  Conditionlbcfpsbet24r as Condition,
  Companion_instance170wh3hu8c61 as Companion_instance_10,
  And1a3dbpwh0hxmu as And,
  Or37bzl6q9twftg as Or,
  Notasovrzfq2v0i as Not,
  Equal31pr842ymh8s6 as Equal,
  NotEqual3by2u1rdr6xhj as NotEqual,
  Inside34e21e5w7gmr5 as Inside,
  NotInside2gyw9f0e86unn as NotInside,
  GreaterThan3vt01ywx1j4sj as GreaterThan,
  LessThan328qpp4kkt6qa as LessThan,
  GreaterThanOrEqual3ghjzsakr35no as GreaterThanOrEqual,
  LessThanOrEqual3o5tj78evuy34 as LessThanOrEqual,
  IntBitsClearbho942xfl833 as IntBitsClear,
  IntBitsSetumkgdrh8gq7a as IntBitsSet,
  IntBitsAnyClear3t38gmzr6rff9 as IntBitsAnyClear,
  IntBitsAnySet1h0wqrlg4jeoy as IntBitsAnySet,
  ListAllElements2qkljsceytb8 as ListAllElements,
  ListAnyElements3oaaxxe9tp3p5 as ListAnyElements,
  ListSizesEquals1le0b8ydqpsi0 as ListSizesEquals,
  SetAllElementso97viygbubrg as SetAllElements,
  SetAnyElements2se8zlywewplk as SetAnyElements,
  SetSizesEquals3hpr35evyoger as SetSizesEquals,
  Exists1exqiojwnd9mi as Exists,
  IfNotNullvieyp8szlv3m as IfNotNull,
  Companion_instance326hk1r71xax as Companion_instance_11,
  Companion_getInstance2w0ry8ukons4w as Companion_getInstance,
  Companion_instancehonhf7q97gvq as Companion_instance_12,
  Companion_getInstance1r7wm1v3dq4i3 as Companion_getInstance_0,
  Companion_instance1xqhrale4ydxi as Companion_instance_13,
  Companion_instance2igigxyt265zn as Companion_instance_14,
  Companion_instanceheuor90dqw2p as Companion_instance_15,
  Companion_instance1rv4h7xeh426o as Companion_instance_16,
  Companion_instance9b6acjoxpq0c as Companion_instance_17,
  Companion_instance3s54ycq8t72xu as Companion_instance_18,
  Companion_getInstance2n1o7xahtwe38 as Companion_getInstance_1,
  OnField2kq8b4gk936v8 as OnField,
  IfIsType2zdboewhql4da as IfIsType,
  GeoDistance1rltmqiyjdtif as GeoDistance,
  StringContains1bog4sdhgv5sy as StringContains,
  RegexMatchese9oiefmyt4mq as RegexMatches,
  Neverceenm6qv9xac as Never,
  Always2gnog82xa5sk4 as Always,
  RawStringContains3pup1bkmqxswn as RawStringContains,
  OnKey39cswdy1celtm as OnKey,
  FullTextSearch2zmuqp5auopao as FullTextSearch,
  Companion_instancefyqtx24roelu as Companion_instance_19,
  Companion_instance15i08a3149tp6 as Companion_instance_20,
  Companion_instance2sjog5kofh6gw as Companion_instance_21,
  Companion_instance2j477vxcf0eam as Companion_instance_22,
  Companion_instance334xz54gwgpk7 as Companion_instance_23,
  Companion_instance2auwgabo579v8 as Companion_instance_24,
  Companion_instance28iz6ufuyency as Companion_instance_25,
} from './Condition.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Option33wwe88i3c121 as Option,
  MySealedClassSerializerpklrcjai1fw6 as MySealedClassSerializer,
  MySealedClassSerializerInterface1lg9fzm3qtbhk as MySealedClassSerializerInterface,
} from './MySealedClassSerializer.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plus310ted5e4i90h as plus,
  plus20p0vtfmu0596 as plus_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  KSerializerKey32hf92q4tsy3p as KSerializerKey,
  innerElement14z17r4weewi9 as innerElement,
  innerElement222h68gtcj2a37 as innerElement2,
  WrappingSerializer1aufse1qyl29g as WrappingSerializer,
} from './SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get_serializableOptions2omofumtgto14 as get_serializableOptions,
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from './SerializableProperty.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { serialNameFQN3cassnowfodm5 as serialNameFQN } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/SerialDescriptor.ext.mjs';
import { Companion_getInstance18mvmiinmr4hw as Companion_getInstance_2 } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { KSerializerWithDefault3c244bl47fg5p as KSerializerWithDefault } from './Defaults.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
  serializer1hu9wv9at41ww as serializer,
  get_nullable197rfua9r7fsz as get_nullable,
  serializer1x79l67jvwntn as serializer_0,
  MapSerializer11kmegt3g5c1g as MapSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer_1 } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { setOf45ia9pnfhe90 as setOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  _SealedTypeDiscriminator___init__impl__jf77jnb2draso4x6g as _SealedTypeDiscriminator___init__impl__jf77jn,
  _SealedTypeDiscriminator___get_serialName__impl__x46m55cpdzns363t1u as _SealedTypeDiscriminator___get_serialName__impl__x46m55,
  variantShortNamey38i8usgp8vx as variantShortName,
} from './SealedTypeDiscriminator.mjs';
import { plus1ogy4liedzq5j as plus_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { GeoCoordinate2xsokvzumk7qu as GeoCoordinate } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/GeoCoordinate.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_intOptions() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return intOptions;
}
var intOptions;
function get_geocoordinateOptions() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return geocoordinateOptions;
}
var geocoordinateOptions;
function get_stringOptions() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return stringOptions;
}
var stringOptions;
function get_cache() {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return cache;
}
var cache;
function comparableOptions(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(inner);
  var tmp_0 = Companion_instance.serializer_qelnde_k$(inner);
  var tmp_1 = new (Option())(tmp_0, 'GreaterThan', VOID, VOID, 45, comparableOptions$lambda);
  var tmp_2 = Companion_instance_0.serializer_qelnde_k$(inner);
  var tmp_3 = new (Option())(tmp_2, 'LessThan', VOID, VOID, 45, comparableOptions$lambda_0);
  var tmp_4 = Companion_instance_1.serializer_qelnde_k$(inner);
  var tmp_5 = new (Option())(tmp_4, 'GreaterThanOrEqual', VOID, VOID, 45, comparableOptions$lambda_1);
  var tmp_6 = Companion_instance_2.serializer_qelnde_k$(inner);
  return plus(tmp, listOf([tmp_1, tmp_3, tmp_5, new (Option())(tmp_6, 'LessThanOrEqual', VOID, VOID, 45, comparableOptions$lambda_2)]));
}
function commonOptions(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = Never_getInstance().serializer_9w0wvi_k$();
  var tmp_0 = new (Option())(tmp, 'Never', VOID, VOID, 20, commonOptions$lambda);
  var tmp_1 = Always_getInstance().serializer_9w0wvi_k$();
  var tmp_2 = new (Option())(tmp_1, 'Always', VOID, VOID, 20, commonOptions$lambda_0);
  var tmp_3 = Companion_instance_3.serializer_qelnde_k$(inner);
  var tmp_4 = new (Option())(tmp_3, 'And', VOID, VOID, 20, commonOptions$lambda_1);
  var tmp_5 = Companion_instance_4.serializer_qelnde_k$(inner);
  var tmp_6 = new (Option())(tmp_5, 'Or', VOID, VOID, 20, commonOptions$lambda_2);
  var tmp_7 = Companion_instance_5.serializer_qelnde_k$(inner);
  var tmp_8 = new (Option())(tmp_7, 'Not', VOID, VOID, 20, commonOptions$lambda_3);
  var tmp_9 = Companion_instance_6.serializer_qelnde_k$(inner);
  var tmp_10 = new (Option())(tmp_9, 'Equal', VOID, VOID, 50, commonOptions$lambda_4);
  var tmp_11 = Companion_instance_7.serializer_qelnde_k$(inner);
  var tmp_12 = new (Option())(tmp_11, 'NotEqual', VOID, VOID, 40, commonOptions$lambda_5);
  var tmp_13 = Companion_instance_8.serializer_qelnde_k$(inner);
  var tmp_14 = new (Option())(tmp_13, 'Inside', VOID, VOID, 40, commonOptions$lambda_6);
  var tmp_15 = Companion_instance_9.serializer_qelnde_k$(inner);
  return listOf([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, new (Option())(tmp_15, 'NotInside', VOID, VOID, 40, commonOptions$lambda_7)]);
}
var ConditionSerializerClass;
function ConditionSerializer() {
  if (ConditionSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        var tmp = this;
        var tmp0 = get_cache();
        // Inline function 'kotlin.collections.getOrPut' call
        var key = KSerializerKey().new_com_lightningkite_services_database_KSerializerKey_4fta1q_k$(inner);
        var value = tmp0.get_wei43m_k$(key);
        var tmp_0;
        if (value == null) {
          var answer = new (MySealedClassSerializer())('com.lightningkite.services.database.Condition', () => {
            var tmp;
            if (inner.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$()) {
              var tmp_0 = innerElement(inner);
              tmp = nullableOptions(isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE());
            } else if (serialNameFQN(inner.get_descriptor_wjt6a0_k$()) === 'kotlin.String') {
              tmp = get_stringOptions();
            } else if (Companion_getInstance_2().serialNames_1.contains_aljjnj_k$(inner.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$())) {
              tmp = rawStringOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (inner.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === 'kotlin.Int') {
              tmp = get_intOptions();
            } else if (serialNameFQN(inner.get_descriptor_wjt6a0_k$()) === 'com.lightningkite.services.data.GeoCoordinate') {
              tmp = get_geocoordinateOptions();
            } else if (equals(inner.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), MAP_getInstance())) {
              tmp = stringMapOptions(innerElement2(inner));
            } else if (equals(inner.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), LIST_getInstance())) {
              tmp = contains(inner.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'Set') ? setOptions(innerElement(inner)) : listOptions(innerElement(inner));
            } else if (!(get_serializableProperties(inner) == null)) {
              tmp = classOptionsReflective(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (!(get_serializableOptions(inner) == null)) {
              tmp = polymorphicOptions(inner);
            } else {
              tmp = comparableOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            }
            var r = tmp;
            return isInterface(r, KtList()) ? r : THROW_CCE();
          });
          tmp0.put_4fpzoq_k$(key, answer);
          tmp_0 = answer;
        } else {
          tmp_0 = value;
        }
        var tmp_1 = tmp_0;
        tmp.$$delegate_0__1 = isInterface(tmp_1, MySealedClassSerializerInterface()) ? tmp_1 : THROW_CCE();
        this.inner_1 = inner;
      }
      get_options_jecmyz_k$() {
        return this.$$delegate_0__1.get_options_jecmyz_k$();
      }
      get_default_qtagd4_k$() {
        return this.$$delegate_0__1.get_default_qtagd4_k$();
      }
      get_descriptor_wjt6a0_k$() {
        return this.$$delegate_0__1.get_descriptor_wjt6a0_k$();
      }
      serialize_92cy8f_k$(encoder, value) {
        this.$$delegate_0__1.serialize_5ase3y_k$(encoder, value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_92cy8f_k$(encoder, value instanceof Condition() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return this.$$delegate_0__1.deserialize_sy6x50_k$(decoder);
      }
    }
    initMetadataForClass($, 'ConditionSerializer', VOID, VOID, [MySealedClassSerializerInterface(), KSerializerWithDefault()]);
    ConditionSerializerClass = $;
  }
  return ConditionSerializerClass;
}
var ConditionAndSerializerClass;
function ConditionAndSerializer() {
  if (ConditionAndSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.And');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return ListSerializer(Companion_instance_10.serializer_qelnde_k$(this.inner_1));
      }
      inner_3lsk1w_k$(it) {
        return it.conditions_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_3lsk1w_k$(it instanceof And() ? it : THROW_CCE());
      }
      outer_xww1sv_k$(it) {
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_xww1sv_k$((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionAndSerializer');
    ConditionAndSerializerClass = $;
  }
  return ConditionAndSerializerClass;
}
var ConditionOrSerializerClass;
function ConditionOrSerializer() {
  if (ConditionOrSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.Or');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return ListSerializer(Companion_instance_10.serializer_qelnde_k$(this.inner_1));
      }
      inner_f11z3q_k$(it) {
        return it.conditions_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_f11z3q_k$(it instanceof Or() ? it : THROW_CCE());
      }
      outer_xww1sv_k$(it) {
        return Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_xww1sv_k$((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionOrSerializer');
    ConditionOrSerializerClass = $;
  }
  return ConditionOrSerializerClass;
}
var ConditionNotSerializerClass;
function ConditionNotSerializer() {
  if (ConditionNotSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.Not');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.inner_1);
      }
      inner_5kao3k_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_5kao3k_k$(it instanceof Not() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return Not().new_com_lightningkite_services_database_Condition_Not_bthq7d_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionNotSerializer');
    ConditionNotSerializerClass = $;
  }
  return ConditionNotSerializerClass;
}
var ConditionEqualSerializerClass;
function ConditionEqualSerializer() {
  if (ConditionEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.Equal');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_o6p069_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_o6p069_k$(it instanceof Equal() ? it : THROW_CCE());
      }
      outer_nxvwks_k$(it) {
        return Equal().new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_nxvwks_k$(it);
      }
    }
    initMetadataForClass($, 'ConditionEqualSerializer');
    ConditionEqualSerializerClass = $;
  }
  return ConditionEqualSerializerClass;
}
var ConditionNotEqualSerializerClass;
function ConditionNotEqualSerializer() {
  if (ConditionNotEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.NotEqual');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_pffxfw_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_pffxfw_k$(it instanceof NotEqual() ? it : THROW_CCE());
      }
      outer_nxvwks_k$(it) {
        return NotEqual().new_com_lightningkite_services_database_Condition_NotEqual_vy8bqe_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_nxvwks_k$(it);
      }
    }
    initMetadataForClass($, 'ConditionNotEqualSerializer');
    ConditionNotEqualSerializerClass = $;
  }
  return ConditionNotEqualSerializerClass;
}
var ConditionInsideSerializerClass;
function ConditionInsideSerializer() {
  if (ConditionInsideSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.Inside');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return SetSerializer(this.inner_1);
      }
      inner_z4szkf_k$(it) {
        return it.values_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_z4szkf_k$(it instanceof Inside() ? it : THROW_CCE());
      }
      outer_sa4rg5_k$(it) {
        return Inside().new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_sa4rg5_k$((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionInsideSerializer');
    ConditionInsideSerializerClass = $;
  }
  return ConditionInsideSerializerClass;
}
var ConditionNotInsideSerializerClass;
function ConditionNotInsideSerializer() {
  if (ConditionNotInsideSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.NotInside');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return SetSerializer(this.inner_1);
      }
      inner_ba2t0k_k$(it) {
        return it.values_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_ba2t0k_k$(it instanceof NotInside() ? it : THROW_CCE());
      }
      outer_sa4rg5_k$(it) {
        return NotInside().new_com_lightningkite_services_database_Condition_NotInside_f2mn7v_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_sa4rg5_k$((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionNotInsideSerializer');
    ConditionNotInsideSerializerClass = $;
  }
  return ConditionNotInsideSerializerClass;
}
var ConditionGreaterThanSerializerClass;
function ConditionGreaterThanSerializer() {
  if (ConditionGreaterThanSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.GreaterThan');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_bcu7q0_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_bcu7q0_k$(it instanceof GreaterThan() ? it : THROW_CCE());
      }
      outer_adyfzm_k$(it) {
        return GreaterThan().new_com_lightningkite_services_database_Condition_GreaterThan_u1sdk2_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_adyfzm_k$((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionGreaterThanSerializer');
    ConditionGreaterThanSerializerClass = $;
  }
  return ConditionGreaterThanSerializerClass;
}
var ConditionLessThanSerializerClass;
function ConditionLessThanSerializer() {
  if (ConditionLessThanSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.LessThan');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_t5165_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_t5165_k$(it instanceof LessThan() ? it : THROW_CCE());
      }
      outer_adyfzm_k$(it) {
        return LessThan().new_com_lightningkite_services_database_Condition_LessThan_vay77v_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_adyfzm_k$((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionLessThanSerializer');
    ConditionLessThanSerializerClass = $;
  }
  return ConditionLessThanSerializerClass;
}
var ConditionGreaterThanOrEqualSerializerClass;
function ConditionGreaterThanOrEqualSerializer() {
  if (ConditionGreaterThanOrEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.GreaterThanOrEqual');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_mxfyc7_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_mxfyc7_k$(it instanceof GreaterThanOrEqual() ? it : THROW_CCE());
      }
      outer_adyfzm_k$(it) {
        return GreaterThanOrEqual().new_com_lightningkite_services_database_Condition_GreaterThanOrEqual_65340f_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_adyfzm_k$((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionGreaterThanOrEqualSerializer');
    ConditionGreaterThanOrEqualSerializerClass = $;
  }
  return ConditionGreaterThanOrEqualSerializerClass;
}
var ConditionLessThanOrEqualSerializerClass;
function ConditionLessThanOrEqualSerializer() {
  if (ConditionLessThanOrEqualSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.LessThanOrEqual');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return this.inner_1;
      }
      inner_ycysjg_k$(it) {
        return it.value_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_ycysjg_k$(it instanceof LessThanOrEqual() ? it : THROW_CCE());
      }
      outer_adyfzm_k$(it) {
        return LessThanOrEqual().new_com_lightningkite_services_database_Condition_LessThanOrEqual_z59w3m_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_adyfzm_k$((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionLessThanOrEqualSerializer');
    ConditionLessThanOrEqualSerializerClass = $;
  }
  return ConditionLessThanOrEqualSerializerClass;
}
var ConditionIntBitsClearSerializerClass;
function ConditionIntBitsClearSerializer() {
  if (ConditionIntBitsClearSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsClearSerializer_instance = null;
        super('com.lightningkite.services.database.Condition.IntBitsClear');
        ConditionIntBitsClearSerializer_instance = this;
      }
      getDeferred_py8w4r_k$() {
        return serializer(IntCompanionObject_instance);
      }
      inner_uybo11_k$(it) {
        return it.mask_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_uybo11_k$(it instanceof IntBitsClear() ? it : THROW_CCE());
      }
      outer_fsmw71_k$(it) {
        return IntBitsClear().new_com_lightningkite_services_database_Condition_IntBitsClear_b2evjq_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_fsmw71_k$((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsClearSerializer');
    ConditionIntBitsClearSerializerClass = $;
  }
  return ConditionIntBitsClearSerializerClass;
}
var ConditionIntBitsClearSerializer_instance;
function ConditionIntBitsClearSerializer_getInstance() {
  if (ConditionIntBitsClearSerializer_instance === VOID)
    new (ConditionIntBitsClearSerializer())();
  return ConditionIntBitsClearSerializer_instance;
}
var ConditionIntBitsSetSerializerClass;
function ConditionIntBitsSetSerializer() {
  if (ConditionIntBitsSetSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsSetSerializer_instance = null;
        super('com.lightningkite.services.database.Condition.IntBitsSet');
        ConditionIntBitsSetSerializer_instance = this;
      }
      getDeferred_py8w4r_k$() {
        return serializer(IntCompanionObject_instance);
      }
      inner_p271i2_k$(it) {
        return it.mask_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_p271i2_k$(it instanceof IntBitsSet() ? it : THROW_CCE());
      }
      outer_fsmw71_k$(it) {
        return IntBitsSet().new_com_lightningkite_services_database_Condition_IntBitsSet_o8ycvz_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_fsmw71_k$((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsSetSerializer');
    ConditionIntBitsSetSerializerClass = $;
  }
  return ConditionIntBitsSetSerializerClass;
}
var ConditionIntBitsSetSerializer_instance;
function ConditionIntBitsSetSerializer_getInstance() {
  if (ConditionIntBitsSetSerializer_instance === VOID)
    new (ConditionIntBitsSetSerializer())();
  return ConditionIntBitsSetSerializer_instance;
}
var ConditionIntBitsAnyClearSerializerClass;
function ConditionIntBitsAnyClearSerializer() {
  if (ConditionIntBitsAnyClearSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsAnyClearSerializer_instance = null;
        super('com.lightningkite.services.database.Condition.IntBitsAnyClear');
        ConditionIntBitsAnyClearSerializer_instance = this;
      }
      getDeferred_py8w4r_k$() {
        return serializer(IntCompanionObject_instance);
      }
      inner_gn91q5_k$(it) {
        return it.mask_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_gn91q5_k$(it instanceof IntBitsAnyClear() ? it : THROW_CCE());
      }
      outer_fsmw71_k$(it) {
        return IntBitsAnyClear().new_com_lightningkite_services_database_Condition_IntBitsAnyClear_r9bmj0_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_fsmw71_k$((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsAnyClearSerializer');
    ConditionIntBitsAnyClearSerializerClass = $;
  }
  return ConditionIntBitsAnyClearSerializerClass;
}
var ConditionIntBitsAnyClearSerializer_instance;
function ConditionIntBitsAnyClearSerializer_getInstance() {
  if (ConditionIntBitsAnyClearSerializer_instance === VOID)
    new (ConditionIntBitsAnyClearSerializer())();
  return ConditionIntBitsAnyClearSerializer_instance;
}
var ConditionIntBitsAnySetSerializerClass;
function ConditionIntBitsAnySetSerializer() {
  if (ConditionIntBitsAnySetSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ConditionIntBitsAnySetSerializer_instance = null;
        super('com.lightningkite.services.database.Condition.IntBitsAnySet');
        ConditionIntBitsAnySetSerializer_instance = this;
      }
      getDeferred_py8w4r_k$() {
        return serializer(IntCompanionObject_instance);
      }
      inner_25jor2_k$(it) {
        return it.mask_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_25jor2_k$(it instanceof IntBitsAnySet() ? it : THROW_CCE());
      }
      outer_fsmw71_k$(it) {
        return IntBitsAnySet().new_com_lightningkite_services_database_Condition_IntBitsAnySet_1myno7_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_fsmw71_k$((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ConditionIntBitsAnySetSerializer');
    ConditionIntBitsAnySetSerializerClass = $;
  }
  return ConditionIntBitsAnySetSerializerClass;
}
var ConditionIntBitsAnySetSerializer_instance;
function ConditionIntBitsAnySetSerializer_getInstance() {
  if (ConditionIntBitsAnySetSerializer_instance === VOID)
    new (ConditionIntBitsAnySetSerializer())();
  return ConditionIntBitsAnySetSerializer_instance;
}
var ConditionListAllElementsSerializerClass;
function ConditionListAllElementsSerializer() {
  if (ConditionListAllElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.ListAllElements');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.inner_1);
      }
      inner_cmttyf_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_cmttyf_k$(it instanceof ListAllElements() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return ListAllElements().new_com_lightningkite_services_database_Condition_ListAllElements_z68vy4_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionListAllElementsSerializer');
    ConditionListAllElementsSerializerClass = $;
  }
  return ConditionListAllElementsSerializerClass;
}
var ConditionListAnyElementsSerializerClass;
function ConditionListAnyElementsSerializer() {
  if (ConditionListAnyElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.ListAnyElements');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.inner_1);
      }
      inner_dvhemm_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_dvhemm_k$(it instanceof ListAnyElements() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return ListAnyElements().new_com_lightningkite_services_database_Condition_ListAnyElements_6syhif_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionListAnyElementsSerializer');
    ConditionListAnyElementsSerializerClass = $;
  }
  return ConditionListAnyElementsSerializerClass;
}
var ConditionListSizesEqualsSerializerClass;
function ConditionListSizesEqualsSerializer() {
  if (ConditionListSizesEqualsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.ListSizesEquals');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return serializer(IntCompanionObject_instance);
      }
      inner_7epuow_k$(it) {
        return it.count_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_7epuow_k$(it instanceof ListSizesEquals() ? it : THROW_CCE());
      }
      outer_fsmw71_k$(it) {
        return ListSizesEquals().new_com_lightningkite_services_database_Condition_ListSizesEquals_7rtnm8_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_fsmw71_k$((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionListSizesEqualsSerializer');
    ConditionListSizesEqualsSerializerClass = $;
  }
  return ConditionListSizesEqualsSerializerClass;
}
var ConditionSetAllElementsSerializerClass;
function ConditionSetAllElementsSerializer() {
  if (ConditionSetAllElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.SetAllElements');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.inner_1);
      }
      inner_qljbd_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_qljbd_k$(it instanceof SetAllElements() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return SetAllElements().new_com_lightningkite_services_database_Condition_SetAllElements_tgnq18_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionSetAllElementsSerializer');
    ConditionSetAllElementsSerializerClass = $;
  }
  return ConditionSetAllElementsSerializerClass;
}
var ConditionSetAnyElementsSerializerClass;
function ConditionSetAnyElementsSerializer() {
  if (ConditionSetAnyElementsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.SetAnyElements');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.inner_1);
      }
      inner_prpp9o_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_prpp9o_k$(it instanceof SetAnyElements() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionSetAnyElementsSerializer');
    ConditionSetAnyElementsSerializerClass = $;
  }
  return ConditionSetAnyElementsSerializerClass;
}
var ConditionSetSizesEqualsSerializerClass;
function ConditionSetSizesEqualsSerializer() {
  if (ConditionSetSizesEqualsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.SetSizesEquals');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return serializer(IntCompanionObject_instance);
      }
      inner_4hify6_k$(it) {
        return it.count_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_4hify6_k$(it instanceof SetSizesEquals() ? it : THROW_CCE());
      }
      outer_fsmw71_k$(it) {
        return SetSizesEquals().new_com_lightningkite_services_database_Condition_SetSizesEquals_nfbfuo_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_fsmw71_k$((!(it == null) ? typeof it === 'number' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionSetSizesEqualsSerializer');
    ConditionSetSizesEqualsSerializerClass = $;
  }
  return ConditionSetSizesEqualsSerializerClass;
}
var ConditionExistsSerializerClass;
function ConditionExistsSerializer() {
  if (ConditionExistsSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.Exists');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_1(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
        return isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
      }
      inner_mj2cup_k$(it) {
        return it.key_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_mj2cup_k$(it instanceof Exists() ? it : THROW_CCE());
      }
      outer_56pmvz_k$(it) {
        return Exists().new_com_lightningkite_services_database_Condition_Exists_m75oda_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_56pmvz_k$((!(it == null) ? typeof it === 'string' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionExistsSerializer');
    ConditionExistsSerializerClass = $;
  }
  return ConditionExistsSerializerClass;
}
var ConditionIfNotNullSerializerClass;
function ConditionIfNotNullSerializer() {
  if (ConditionIfNotNullSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('com.lightningkite.services.database.Condition.IfNotNull');
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.inner_1);
      }
      inner_hzorue_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_hzorue_k$(it instanceof IfNotNull() ? it : THROW_CCE());
      }
      outer_gq7unn_k$(it) {
        return IfNotNull().new_com_lightningkite_services_database_Condition_IfNotNull_b1oyp_k$(it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_gq7unn_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionIfNotNullSerializer');
    ConditionIfNotNullSerializerClass = $;
  }
  return ConditionIfNotNullSerializerClass;
}
function nullableOptions(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(get_nullable(inner));
  var tmp_0 = Companion_instance_11.serializer_qelnde_k$(inner);
  return plus(tmp, listOf_0(new (Option())(tmp_0, 'IfNotNull', VOID, VOID, 90, nullableOptions$lambda)));
}
function rawStringOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = comparableOptions(element);
  var tmp_0 = Companion_getInstance().serializer_qelnde_k$(element);
  var tmp_1 = setOf_0(['Search', 'RawStringContains']);
  return plus(tmp, listOf_0(new (Option())(tmp_0, 'StringContains', tmp_1, VOID, 60, rawStringOptions$lambda)));
}
function stringMapOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(MapSerializer(serializer_0(StringCompanionObject_instance), element));
  var tmp_0 = Companion_instance_12.serializer_r07i7m_k$(element);
  var tmp_1 = new (Option())(tmp_0, 'Exists', VOID, VOID, 60, stringMapOptions$lambda);
  var tmp_2 = Companion_getInstance_0().serializer_r07i7m_k$(element);
  return plus(tmp, listOf([tmp_1, new (Option())(tmp_2, 'OnKey', VOID, VOID, 60, stringMapOptions$lambda_0)]));
}
function setOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(SetSerializer(element));
  var tmp_0 = Companion_instance_13.serializer_szze8_k$(element);
  var tmp_1 = setOf_0(['ListAllElements', 'AllElements']);
  var tmp_2 = new (Option())(tmp_0, 'SetAllElements', tmp_1, VOID, 60, setOptions$lambda);
  var tmp_3 = Companion_instance_14.serializer_szze8_k$(element);
  var tmp_4 = setOf_0(['ListAnyElements', 'AnyElements']);
  var tmp_5 = new (Option())(tmp_3, 'SetAnyElements', tmp_4, VOID, 60, setOptions$lambda_0);
  var tmp_6 = Companion_instance_15.serializer_szze8_k$(element);
  var tmp_7 = setOf_0(['ListSizesEquals', 'SizesEquals']);
  return plus(tmp, listOf([tmp_2, tmp_5, new (Option())(tmp_6, 'SetSizesEquals', tmp_7, VOID, 55, setOptions$lambda_1)]));
}
function listOptions(element) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(ListSerializer(element));
  var tmp_0 = Companion_instance_16.serializer_szze8_k$(element);
  var tmp_1 = setOf_0(['SetAllElements', 'AllElements']);
  var tmp_2 = new (Option())(tmp_0, 'ListAllElements', tmp_1, VOID, 60, listOptions$lambda);
  var tmp_3 = Companion_instance_17.serializer_szze8_k$(element);
  var tmp_4 = setOf_0(['SetAnyElements', 'AnyElements']);
  var tmp_5 = new (Option())(tmp_3, 'ListAnyElements', tmp_4, VOID, 60, listOptions$lambda_0);
  var tmp_6 = Companion_instance_18.serializer_szze8_k$(element);
  var tmp_7 = setOf_0(['SetSizesEquals', 'SizesEquals']);
  return plus(tmp, listOf([tmp_2, tmp_5, new (Option())(tmp_6, 'ListSizesEquals', tmp_7, VOID, 55, listOptions$lambda_1)]));
}
function classOptionsReflective(inner) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(inner);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = ensureNotNull(get_serializableProperties(inner));
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(this_0.length);
  var index = 0;
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp_0 = new (ConditionOnFieldSerializer())(isInterface(item, SerializableProperty()) ? item : THROW_CCE());
    var tmp_1 = item.get_name_woqyms_k$();
    var tmp$ret$4 = new (Option())(tmp_0, tmp_1, VOID, VOID, 80, classOptionsReflective$lambda(inner, _unary__edvuaz));
    destination.add_utx5q5_k$(tmp$ret$4);
  }
  var tmp_2 = plus(tmp, destination);
  var tmp_3 = Companion_getInstance_1().serializer_qelnde_k$(inner);
  return plus_0(tmp_2, new (Option())(tmp_3, 'FullTextSearch', VOID, VOID, 55, classOptionsReflective$lambda_0));
}
function polymorphicOptions(supertype) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  var tmp = commonOptions(supertype);
  // Inline function 'kotlin.collections.map' call
  var this_0 = ensureNotNull(get_serializableOptions(supertype));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var discriminator = _SealedTypeDiscriminator___init__impl__jf77jn(item.serializer_1);
    var tmp_0 = new (ConditionIfIsTypeSerializer())(supertype, item.serializer_1);
    var tmp_1 = _SealedTypeDiscriminator___get_serialName__impl__x46m55(discriminator);
    var tmp_2 = plus_1(item.secondaryNames_1, listOfNotNull(variantShortName(supertype, discriminator)));
    var tmp$ret$2 = new (Option())(tmp_0, tmp_1, tmp_2, VOID, 80, polymorphicOptions$lambda(discriminator));
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  return plus(tmp, destination);
}
var ConditionOnFieldSerializerClass;
function ConditionOnFieldSerializer() {
  if (ConditionOnFieldSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(field) {
        super(field.get_name_woqyms_k$());
        this.field_1 = field;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.field_1.get_serializer_u29zhh_k$());
      }
      inner_gugv1l_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_gugv1l_k$(it instanceof OnField() ? it : THROW_CCE());
      }
      outer_qfl52p_k$(it) {
        return OnField().new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$(this.field_1, it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_qfl52p_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionOnFieldSerializer');
    ConditionOnFieldSerializerClass = $;
  }
  return ConditionOnFieldSerializerClass;
}
var ConditionIfIsTypeSerializerClass;
function ConditionIfIsTypeSerializer() {
  if (ConditionIfIsTypeSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(outer, inner) {
        super('com.lightningkite.services.database.Condition.IfIsType');
        this.outer_1 = outer;
        this.inner_1 = inner;
      }
      getDeferred_py8w4r_k$() {
        return Companion_instance_10.serializer_qelnde_k$(this.inner_1);
      }
      inner_4ok1z6_k$(it) {
        return it.condition_1;
      }
      inner_edgipe_k$(it) {
        return this.inner_4ok1z6_k$(it instanceof IfIsType() ? it : THROW_CCE());
      }
      outer_qfl52p_k$(it) {
        return IfIsType().new_com_lightningkite_services_database_Condition_IfIsType_1eitre_k$(this.inner_1, it);
      }
      outer_ojvjpq_k$(it) {
        return this.outer_qfl52p_k$(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ConditionIfIsTypeSerializer');
    ConditionIfIsTypeSerializerClass = $;
  }
  return ConditionIfIsTypeSerializerClass;
}
function intOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsClear();
}
function intOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsSet();
}
function intOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsAnyClear();
}
function intOptions$lambda_2(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IntBitsAnySet();
}
function geocoordinateOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof GeoDistance();
}
function stringOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof StringContains();
}
function stringOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof RegexMatches();
}
function comparableOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof GreaterThan();
}
function comparableOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof LessThan();
}
function comparableOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof GreaterThanOrEqual();
}
function comparableOptions$lambda_2(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof LessThanOrEqual();
}
function commonOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Never();
}
function commonOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Always();
}
function commonOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof And();
}
function commonOptions$lambda_2(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Or();
}
function commonOptions$lambda_3(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Not();
}
function commonOptions$lambda_4(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Equal();
}
function commonOptions$lambda_5(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof NotEqual();
}
function commonOptions$lambda_6(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Inside();
}
function commonOptions$lambda_7(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof NotInside();
}
function nullableOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof IfNotNull();
}
function rawStringOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof RawStringContains();
}
function stringMapOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof Exists();
}
function stringMapOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof OnKey();
}
function setOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof SetAllElements();
}
function setOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof SetAnyElements();
}
function setOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof SetSizesEquals();
}
function listOptions$lambda(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof ListAllElements();
}
function listOptions$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof ListAnyElements();
}
function listOptions$lambda_1(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof ListSizesEquals();
}
function classOptionsReflective$lambda($inner, $index) {
  return (it) => {
    var tmp;
    if (it instanceof OnField()) {
      tmp = it.key_1.get_name_woqyms_k$() === $inner.get_descriptor_wjt6a0_k$().getElementName_u4sqmf_k$($index);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function classOptionsReflective$lambda_0(it) {
  _init_properties_ConditionSerialization_kt__gb1zm3();
  return it instanceof FullTextSearch();
}
function polymorphicOptions$lambda($discriminator) {
  return (it) => {
    var tmp;
    if (it instanceof IfIsType()) {
      tmp = it.discriminator_1 === $discriminator;
    } else {
      tmp = false;
    }
    return tmp;
  };
}
var properties_initialized_ConditionSerialization_kt_o807ux;
function _init_properties_ConditionSerialization_kt__gb1zm3() {
  if (!properties_initialized_ConditionSerialization_kt_o807ux) {
    properties_initialized_ConditionSerialization_kt_o807ux = true;
    var tmp = comparableOptions(serializer(IntCompanionObject_instance));
    var tmp_0 = Companion_instance_19.serializer_9w0wvi_k$();
    var tmp_1 = new (Option())(tmp_0, 'IntBitsClear', VOID, VOID, 30, intOptions$lambda);
    var tmp_2 = Companion_instance_20.serializer_9w0wvi_k$();
    var tmp_3 = new (Option())(tmp_2, 'IntBitsSet', VOID, VOID, 30, intOptions$lambda_0);
    var tmp_4 = Companion_instance_21.serializer_9w0wvi_k$();
    var tmp_5 = new (Option())(tmp_4, 'IntBitsAnyClear', VOID, VOID, 30, intOptions$lambda_1);
    var tmp_6 = Companion_instance_22.serializer_9w0wvi_k$();
    intOptions = plus(tmp, listOf([tmp_1, tmp_3, tmp_5, new (Option())(tmp_6, 'IntBitsAnySet', VOID, VOID, 30, intOptions$lambda_2)]));
    var tmp_7 = commonOptions(ContextualSerializer().new_kotlinx_serialization_ContextualSerializer_2v3fxc_k$(getKClass(GeoCoordinate())));
    var tmp_8 = Companion_instance_23.serializer_9w0wvi_k$();
    geocoordinateOptions = plus(tmp_7, listOf_0(new (Option())(tmp_8, 'GeoDistance', VOID, VOID, 60, geocoordinateOptions$lambda)));
    var tmp_9 = comparableOptions(serializer_0(StringCompanionObject_instance));
    var tmp_10 = Companion_instance_24.serializer_9w0wvi_k$();
    var tmp_11 = setOf('Search');
    var tmp_12 = new (Option())(tmp_10, 'StringContains', tmp_11, VOID, 60, stringOptions$lambda);
    var tmp_13 = Companion_instance_25.serializer_9w0wvi_k$();
    stringOptions = plus(tmp_9, listOf([tmp_12, new (Option())(tmp_13, 'RegexMatches', VOID, VOID, 45, stringOptions$lambda_0)]));
    cache = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
  }
}
//region block: exports
export {
  ConditionAndSerializer as ConditionAndSerializer19slt89ki7hw0,
  ConditionEqualSerializer as ConditionEqualSerializer1v5lg4nbzxvia,
  ConditionExistsSerializer as ConditionExistsSerializer31noqg0z2vwgv,
  ConditionGreaterThanOrEqualSerializer as ConditionGreaterThanOrEqualSerializer1sx8qme6p7zts,
  ConditionGreaterThanSerializer as ConditionGreaterThanSerializer2wzpqx0pwkin3,
  ConditionIfNotNullSerializer as ConditionIfNotNullSerializer1qp6j6wpu8isv,
  ConditionInsideSerializer as ConditionInsideSerializern68csv6xb4yt,
  ConditionLessThanOrEqualSerializer as ConditionLessThanOrEqualSerializer2d97c0blodzea,
  ConditionLessThanSerializer as ConditionLessThanSerializer3u0xx1qztyncg,
  ConditionListAllElementsSerializer as ConditionListAllElementsSerializer3sgf83jw85zog,
  ConditionListAnyElementsSerializer as ConditionListAnyElementsSerializer22oqge0hpw89f,
  ConditionListSizesEqualsSerializer as ConditionListSizesEqualsSerializerylq6zdmegxn2,
  ConditionNotEqualSerializer as ConditionNotEqualSerializer2051eg4c8s5z1,
  ConditionNotInsideSerializer as ConditionNotInsideSerializerd6z6x5yvnjvh,
  ConditionNotSerializer as ConditionNotSerializer2hwypspkjd4kk,
  ConditionOrSerializer as ConditionOrSerializer3tsbvckybs1gl,
  ConditionSerializer as ConditionSerializer2v4zqxahhdocs,
  ConditionSetAllElementsSerializer as ConditionSetAllElementsSerializer4uu2vw2zw7qo,
  ConditionSetAnyElementsSerializer as ConditionSetAnyElementsSerializer129a7lg9rckmm,
  ConditionSetSizesEqualsSerializer as ConditionSetSizesEqualsSerializerzfwxsye2lusb,
  ConditionIntBitsAnyClearSerializer_getInstance as ConditionIntBitsAnyClearSerializer_getInstance2zhinx3o90y8u,
  ConditionIntBitsAnySetSerializer_getInstance as ConditionIntBitsAnySetSerializer_getInstance4vv5u7v6muh9,
  ConditionIntBitsClearSerializer_getInstance as ConditionIntBitsClearSerializer_getInstance3vhdaz6mubsl2,
  ConditionIntBitsSetSerializer_getInstance as ConditionIntBitsSetSerializer_getInstance11zuknc24w7o9,
};
//endregion

//# sourceMappingURL=ConditionSerialization.mjs.map
